module.exports = __webpack_public_path__ + "img/0-lg.3b7a82ac.jpg";